type WorkflowEditorLoadStateInput = {
  hasRouteWorkflowId: boolean
  hasWorkflowData: boolean
  isError: boolean
  isLoading: boolean
}

export type WorkflowEditorLoadState = "loading" | "error" | "ready"

export function getWorkflowEditorLoadState({
  hasRouteWorkflowId,
  hasWorkflowData,
  isError,
  isLoading,
}: WorkflowEditorLoadStateInput): WorkflowEditorLoadState {
  if (!hasRouteWorkflowId) return "ready"
  if (isLoading) return "loading"
  if (isError || !hasWorkflowData) return "error"
  return "ready"
}
